import React from "react";
import { useSelector } from "react-redux";
import { __ } from "services/Translator";
import useOpenSupport from "stores/support/useOpenSupport";
import {
  selectSupportOpen,
  selectSupportUnreadTotal,
} from "stores/support/supportSelectors";

export default function SupportLauncher() {
  const support = useOpenSupport();
  const open = useSelector(selectSupportOpen);
  const unread = useSelector(selectSupportUnreadTotal);

  return (
    <button
      type="button"
      className={"supportLauncher" + (open ? " isOpen" : "")}
      onClick={support.toggle}
      aria-label={open ? __("Close support") : __("Open support")}
      aria-expanded={!!open}
      aria-haspopup="dialog"
    >
      <span className="supportLauncherIcon" aria-hidden="true">
        {open ? (
          <svg viewBox="0 0 24 24" width="22" height="22" focusable="false">
            <path
              d="M6 6l12 12M18 6L6 18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="24" height="24" focusable="false">
            <path
              d="M12 3c-4.97 0-9 3.36-9 7.5 0 2.3 1.24 4.36 3.2 5.73V21l3.4-2.1c.77.16 1.58.25 2.4.25 4.97 0 9-3.36 9-7.65S16.97 3 12 3z"
              fill="currentColor"
            />
          </svg>
        )}
      </span>
      {unread > 0 && (
        <span className="supportLauncherBadge">
          <span className="visuallyHidden">{__("Unread messages")}</span>
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
}
